/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_PartialInputs */

const vi_order_payment_partial = /** @type {(inputs: Order_Payment_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán một phần`)
};

/**

* @param {Order_Payment_PartialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_partial = /** @type {((inputs?: Order_Payment_PartialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_PartialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_partial(inputs)
});